import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import moment from 'moment'

import { CoproFicheEdit } from '../copros_fiche'

import { Events } from '../components/copros/Events.js'
import Api from '../Apis/api.service'
import DateRangePicker from '../components/common/DateRangePicker/DateRangePicker'

import '../components/common/DateRangePicker/DateRangePickerStyles.css'

import { TicketList } from '../tickets_generic'

import { TicketListDraft } from '../ticket_list_draft'
import { Box, Grid, Paper } from '@material-ui/core'
import EmployeGuardianForm from './partials/EmployeGuardianForm.js'
import { Documents } from './partials/Documents'
import { BankingHistoryIntranet } from '../intranet/BankingHistory'

import BusinessIcon from '@mui/icons-material/Business'
import AllInboxIcon from '@mui/icons-material/AllInbox'
import AssignmentIcon from '@mui/icons-material/Assignment'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import FolderCopyIcon from '@mui/icons-material/FolderCopy'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import GroupsIcon from '@mui/icons-material/Groups' // after the tab coproprietaires on develop we will use it
import { CoownersList } from '../intranet/CoownersList'

const CoproShow = () => {
  const { id } = useParams()
  const [choicesCategories, setChoicesCategories] = useState([])
  const [choicesTypes, setChoicesTypes] = useState([])
  const [tabIndex, setTabIndex] = useState(0)
  const [events, setEvents] = useState([])
  const [ficheImmeuble, setFicheImmeuble] = useState(null)
  const [copromondayID, setCoproMondayID] = useState(null)
  const [copro, setCopro] = useState(null)

  const [dateRange, setDateRange] = useState({
    startDate: moment().subtract(5, 'month').toDate(),
    endDate: moment().toDate(),
    key: 'selection',
  })

  const handleSelect = (ranges) => {
    setDateRange({
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate,
      key: 'selection',
    })
  }
  if (!id) {
    return null
  }

  const getEvents = useCallback(async () => {
    Api.copros
      .getEventsFromCopro(
        id,
        moment(dateRange.startDate).format('YYYY-MM-DD'),
        moment(dateRange.endDate).format('YYYY-MM-DD')
      )
      .then((response) => {
        setEvents(response.data)
        if (response.data.length === 0) {
          setEvents([
            {
              title: "Pas d'événements",
              id: '0',
              type: null,
              description: "Pas d'événements pour cette période",
            },
          ])
        }
      })
      .catch((error) => {
        setEvents([])
        console.log('error', error)
      })
    Api.copros.getFicheImmeubleFromCopro(id).then((response) => {
      setFicheImmeuble(response.data.copro_fiche_id)
      setCoproMondayID(response.data.copro_monday_id)
    })
  }, [id, dateRange])

  useEffect(() => {
    getEvents()
  }, [dateRange])

  const getChoicesFilters = async (copro_id) => {
    const res = await Api.copros.getCoproChoicesDocs(copro_id)
    if (res.status == 200) {
      setChoicesCategories(() => {
        return res.data.categories
      })
      setChoicesTypes(() => {
        return res.data.types
      })
    }
  }
  const getDetailsCopro = async (copro_id) => {
    const res = await Api.copros.getDetailsCopro(copro_id)
    if (res.status == 200) {
      setCopro(() => {
        return res.data
      })
    }
  }
  useEffect(() => {
    getDetailsCopro(id)
    getChoicesFilters(id)
  }, [id])

  const handleChange = (_, newValue) => {
    setTabIndex(newValue)
  }

  return (
    <>
      <Grid container spacing={1} sx={{ px: 2 }}>
        <Grid item xs={7}>
          <Box sx={{ borderBottom: 1 }}>
            <Tabs
              style={{
                marginBottom: '1em',
                marginTop: '1em',
              }}
              TabIndicatorProps={{
                style: {
                  backgroundColor: '#ffda85b0',
                },
              }}
              value={tabIndex}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
            >
              <Tab icon={<BusinessIcon />} label="Fiche immeuble" />
              <Tab icon={<AllInboxIcon />} label="Demandes" />
              <Tab icon={<AssignmentIcon />} label="Tickets" />
              <Tab icon={<AssignmentIndIcon />} label="Employés et Gardiens" />
              <Tab icon={<FolderCopyIcon />} label="Documents" />
              <Tab icon={<AccountBalanceIcon />} label="Compte bancaire" />
              <Tab icon={<GroupsIcon />} label="Copropriétaires" />
            </Tabs>
          </Box>
          <Box sx={{ margin: 2 }}>
            {tabIndex === 0 && (
              <Paper variant="outlined">
                {ficheImmeuble && (
                  <>
                    <CoproFicheEdit
                      redirect={false}
                      resource="copros_fiche"
                      id={ficheImmeuble}
                      copro={copro}
                      refresh={() => {
                        getDetailsCopro(id)
                      }}
                    />
                  </>
                )}
              </Paper>
            )}
            {tabIndex === 1 && (
              <Grid item xs={12}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TicketListDraft
                    filter={{
                      copro_id: copromondayID,
                    }}
                  />
                </Box>
              </Grid>
            )}
            {tabIndex === 2 && (
              <Grid item xs={12}>
                <>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TicketList
                      filter={{
                        copro_id: copromondayID,
                      }}
                    />
                  </Box>
                </>
              </Grid>
            )}
            {tabIndex === 3 && (
              <>
                <EmployeGuardianForm id={ficheImmeuble} />
              </>
            )}
          </Box>
        </Grid>
        {tabIndex === 4 && (
          <Grid item xs={12}>
            <>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Documents
                  copro={copro}
                  copro_id={id}
                  ficheImmeuble={ficheImmeuble}
                  choicesCategories={choicesCategories}
                  choicesTypes={choicesTypes}
                />
              </Box>
            </>
          </Grid>
        )}
        {tabIndex === 5 && (
          <Grid item xs={12}>
            <BankingHistoryIntranet coproId={copro.internal_id} />
          </Grid>
        )}
        {tabIndex === 6 && (
          <Grid item xs={12}>
            <CoownersList copro_id={id} />
          </Grid>
        )}
        {tabIndex === 0 && (
          <Grid
            style={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'column',
              flexWrap: 'nowrap',
            }}
            item
            xs={5}
          >
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'baseline',
              }}
            >
              <DateRangePicker
                handleSelect={handleSelect}
                ranges={dateRange}
                collapsed={true}
                maxDate={new Date()}
                style={{
                  fontSize: '.95em',
                  justifyContent: 'center',
                  marginTop: '1em',
                }}
                source={'copros'}
              />
            </Box>
            <Box sx={{ margin: 2 }}>
              <Paper
                variant="outlined"
                sx={{ my: { xs: 2, md: 5 }, p: { xs: 1, md: 2 } }}
              >
                <Grid item display="flex">
                  {events &&
                    events.map((event, index) => (
                      <Events key={index} event={event} />
                    ))}
                </Grid>
              </Paper>
            </Box>
          </Grid>
        )}
      </Grid>
    </>
  )
}
export default CoproShow
